export const ResponsableTableHelpers = {
    data() {
        return {
            tableColumns: [
                ['OEYC', 'OENY', 'OICC'].includes(this.activity) && ['PAFIR'].includes(this.type) ? {
                    title: "Campo de Ensayo / Calibración",
                    type: 'text',
                    key: 'field',

                } : {},
                {
                    title: "Nombre y Apellidos Completos",
                    type: 'text',
                    key: 'name',

                },
                ['RFA1', 'RFA2', 'DTL', 'RL', 'ARTN', 'RTOI', 'PDEA', 'RFOC'].includes(this.type)
                    || (['OCLN'].includes(this.activity) && ['PAFIR'].includes(this.type))
                    || (['OCLN'].includes(this.activity) && ['RSGC'].includes(this.type)) ? {
                    title: "Número de Cédula",
                    type: 'text',
                    key: 'taxid',

                } : {},
                ['DTL', 'RSGC1', 'DTPEA', 'RSGC', 'CTCP', 'RTOI'].includes(this.type) ? {
                    title: "Titular (1) Sustituto (2)",
                    type: 'text',
                    key: 'head',

                } : {},
                ['OEYC', 'OENY'].includes(this.activity) && ['RFA1', 'RFA2'].includes(this.type) ? {
                    title: "Responsable",
                    type: 'text',
                    key: 'responsable',

                } : {},
                ['DTL', 'RSGC', 'DTPEA', 'CTCP', 'PDEA', 'RFOC'].includes(this.type)
                    || (['OICC'].includes(this.activity) && ['RFA1', 'RFA2'].includes(this.type))
                    || (['OCPE'].includes(this.activity) && ['RL'].includes(this.type)) ? {
                    title: "Cargo",
                    type: 'text',
                    key: 'position',

                } : {},
                ['PAFIR'].includes(this.type) ? {
                    title: "Calificación",
                    type: 'text',
                    key: 'qualification',

                } : {},
                ['OCLN'].includes(this.activity) && ['PAFIR'].includes(this.type) ? {
                    title: "Campo de Análisis",
                    type: 'text',
                    key: 'field',

                } : {},
                ['CTCP'].includes(this.type) ? {
                    title: "Programa",
                    type: 'text',
                    key: 'program',

                } : {},
                ['RTOI'].includes(this.type) ? {
                    title: "Alcance Bajo su Responsabilidad",
                    type: 'text',
                    key: 'scope',

                } : {},
                ['ARTN'].includes(this.type) || (['OINSP'].includes(this.activity) && ['RL'].includes(this.type)) ? {
                    title: "Teléfono",
                    type: 'text',
                    key: 'phone',

                } : {},
                ['RFA1', 'RFA2', 'DTL', 'RSGC', 'DTPEA', 'CTCP', 'RL', 'ARTN', 'RTOI', 'PDEA', 'RFOC'].includes(this.type) ? {
                    title: "E-mail",
                    type: 'text',
                    key: 'email',

                } : {},
            ],
            actionObj: {
                title: 'Acción',
                type: 'action',
            }
        }
    },
}